module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "term-page"
  }, [_c('div', {
    staticClass: "foo term-page__header"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_term_title')))]), _vm._v(" "), _c('div', {
    staticClass: "term-page__actions"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.addTerm
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_add_term')))]), _vm._v(" "), (_vm.role === 'ROLE_SUPER_ADMIN') ? _c('span', [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.createSlots
    }
  }, [_c('i', {
    staticClass: "ti-hand-open"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_open_term')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "term-page__search-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "term-page__bulk-actions"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filter.length > 0 && _vm.filteredTerms.length > 0),
      expression: "filter.length > 0 && filteredTerms.length > 0"
    }],
    staticClass: "new-button",
    on: {
      "click": _vm.deleteFiltered
    }
  }, [_c('i', {
    staticClass: "ti-trash"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete_searched_terms')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "wod-container term-page__grid"
  }, _vm._l((_vm.days), function(item) {
    return _c('div', {
      staticClass: "term-item w-full term-page__day-card"
    }, [_c('div', {
      staticClass: "w-full text-center term-page__day-title"
    }, [_vm._v(_vm._s(_vm.convertDayToRs(item)))]), _vm._v(" "), _vm._l((_vm.filteredTerms.filter(function (f) { return f.day === item; })), function(term) {
      return _c('div', {
        staticClass: "section-top-xs"
      }, [_c('div', {
        staticClass: "term-subitem",
        style: (_vm.getBorderColorForType(term.trainingType))
      }, [_c('p', {
        staticClass: "term-page__slot-title",
        style: (_vm.getDynamicColor('ti_title'))
      }, [_vm._v(_vm._s(term.trainingType) + " - " + _vm._s(term.startAt))]), _vm._v(" "), _c('p', {
        staticClass: "term-subitem-medium term-page__slot-meta",
        style: (_vm.getDynamicColor('ti_title'))
      }, [_vm._v(_vm._s(_vm.locale.t('label_max_people')) + ": "), _c('b', [_vm._v(_vm._s(term.maxTrainings))])]), _vm._v(" "), (term.trainerOnSlot != null) ? _c('p', {
        staticClass: "term-subitem-medium term-page__slot-meta",
        style: (_vm.getDynamicColor('ti_title'))
      }, [_vm._v(_vm._s(_vm.locale.t('label_trainer_name')) + ": "), _c('b', [_vm._v(_vm._s(term.trainerOnSlot))])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "flex-container section-top-sm"
      }, [_c('div', {
        staticClass: "new-button term-subitem-small",
        on: {
          "click": function($event) {
            return _vm.editTerm(term)
          }
        }
      }, [_c('i', {
        staticClass: "ti-pencil"
      }), _vm._v(" " + _vm._s(_vm.locale.t('label_edit')) + "\n                ")]), _vm._v(" "), _c('div', {
        staticClass: "new-button term-subitem-small",
        on: {
          "click": function($event) {
            return _vm.deleteTerm(term)
          }
        }
      }, [_c('i', {
        staticClass: "ti-trash"
      }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n                ")])])])])
    })], 2)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ce646c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Term/Term.vue
// module id = 726
// module chunks = 0